import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, defineComponent } from 'vue'
const _hoisted_1 = {
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink',
  x: '0px',
  y: '0px',
  viewBox: '0 0 512 512',
  'enable-background': 'new 0 0 512 512',
  'xml:space': 'preserve'
}
const _hoisted_2 = /*#__PURE__*/ _createElementVNode(
  'g',
  null,
  [
    /*#__PURE__*/ _createElementVNode('path', {
      d: 'M149.6,283.3c-51.9,0-83.9,45.7-83.9,95.1c0,21.3-10.9,37.1-31.4,46.4c-2.2,1-3,3.8-1.7,5.8c16.7,24.6,63.3,33.3,95.3,33.3\n\t\tc8.4,0,15.9-0.6,21.8-1.7c35.6-6.4,80.1-24.9,90.7-77C252.6,324.7,201.5,283.3,149.6,283.3z'
    }),
    /*#__PURE__*/ _createElementVNode('path', {
      d: 'M467.7,60.4C460,52.7,450.9,48,441.6,48c-6.3,0-12.7,2.2-18.8,7L257.7,200.3c-5.4,4.8-12.4,7.4-19.7,7.4l-0.1,0\n\t\tc0,0-0.1,0-0.1,0c-5.6,0-11.1,2.1-15.4,5.8l-53.6,43.8c-2.1,1.8-2.7,4.8-1.4,7.2l0,0c0.9,1.7,2.6,2.9,4.5,3.1\n\t\tc45.6,4.5,87,37,87.3,86.6c0,1.7,0.7,3.4,2,4.5c2.5,2.1,6,1.7,8-0.6l45.1-52.2c3.5-4,5.8-9.1,6-14.5c0-0.4,0-0.8,0-1.2\n\t\tc0-7.5,3-14.8,8-20.4l144.8-164.4C485,90.3,480.7,73.3,467.7,60.4z'
    })
  ],
  -1
  /* HOISTED */
)
const _hoisted_3 = [_hoisted_2]
export default defineComponent({
  name: 'IosBrush',
  render: function render(_ctx, _cache) {
    return _openBlock(), _createElementBlock('svg', _hoisted_1, _hoisted_3)
  }
})
